// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3L4Gj","right":"styles_right__3nbeI"};